package com.swetdot.swetgram.ui.links

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.swetdot.swetgram.data.links.LinkRepository
import com.swetdot.swetgram.protocol.dto.ResolvedLink
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class LinkResolverUiState(
    val loading: Boolean = true,
    val resolved: ResolvedLink? = null,
    val failed: Boolean = false,
)

class LinkResolverViewModel(
    private val link: ExternalLink,
    private val links: LinkRepository,
) : ViewModel() {
    private val mutableState = MutableStateFlow(LinkResolverUiState())
    val state: StateFlow<LinkResolverUiState> = mutableState.asStateFlow()

    init {
        load()
    }

    fun resolve() {
        if (mutableState.value.loading) return
        load()
    }

    private fun load() {
        mutableState.update { it.copy(loading = true, failed = false) }
        viewModelScope.launch {
            runCatching { links.resolve(link.canonicalUrl) }
                .onSuccess { result ->
                    mutableState.value = LinkResolverUiState(loading = false, resolved = result)
                }
                .onFailure {
                    mutableState.value = LinkResolverUiState(loading = false, failed = true)
                }
        }
    }
}
